export enum AccessPermission{
  NoAccess = 0,
  ReadAccess = 1,
  WriteAccess = 2,
  ExecuteAccess = 3
};
